
@if(!copyProjectStarted){
<h1 *ngIf="projectOperation == 'ADD'" mat-dialog-title>Add Project</h1>
<h1 *ngIf="projectOperation == 'EDIT'" mat-dialog-title>Edit Project</h1>

<mat-dialog-content>
  <div class="row mt-2">
    <div class="col-8">

      <div class="form-field">
        <mat-form-field appearance="outline">
          <mat-label>Project Name</mat-label>
          <input matInput placeholder="Project Name" [(ngModel)]="projectName" required (input)="onProjectNameChange()" />
          <mat-hint class="error-message" *ngIf="(existProject && projectOperation == 'ADD') || (existProject && projectOperation == 'EDIT' && projectName?.toLowerCase()?.trim() !== projectData?.project_name?.toLowerCase()?.trim())">This project name already exists!</mat-hint>
          <mat-error *ngIf="!projectName">
            Project name is required.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-field mt-1">
        <mat-form-field appearance="outline">
          <mat-label>Project Description</mat-label>
          <textarea matInput placeholder="Project Description" [(ngModel)]="projectDescription" (input)="descriptionChange()"></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="col-4">
      <div class="app-icon-container">
        
        <div class="icon-img-container" matRipple (click)="fileInput.click()">
          <input #fileInput type="file" onclick="this.value = null" (change)="onFileSelected($event)" style="display: none;" accept="image/*">
          <img [src]="timeStampEnable ? (imageSrc + '?cache=' + lastModifiedDate) : imageSrc" class="w-100" alt="" >
          <div class="edit-icon">
            <mat-icon>edit</mat-icon>
          </div>
        </div>
        <div class="hint"[class.text-danger]="showImageTypeError">{{showImageTypeError ? "Invalid file type. Please select an image." : "App Icon"}}</div>
      </div>
    </div>
  </div>
  <div class="row mt-1">
    <div class="d-flex w-100 justify-content-end">
        <button mat-raised-button (click)="copyProject()">Copy form existing project</button>
      </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="dailog-footer-buttons">
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSaveClick()" [disabled]="(projectOperation === 'EDIT' && (isDataChanged || (existProject && projectName.toLowerCase().trim() != projectData.project_name.toLowerCase().trim()))) || !isFormValid || ((existProject && projectOperation == 'ADD')) || showImageTypeError">Save</button>
</mat-dialog-actions>
<vl-spinner id="project_new" [show]="spinnerVisible"></vl-spinner>
}@else {
  <div class="copy-project">
  <h2 mat-dialog-title>Copy Existing Project</h2>

<mat-dialog-content class="dialog-content">
  <div class="section">
    <label class="label">Select from</label>
    <mat-radio-group [(ngModel)]="selectedServer" (ngModelChange)="fetchProjectsBasedOnServer()">
      <mat-radio-button *ngIf="currentEnv !== 'dev'" value="dev">Development Server</mat-radio-button>
      <mat-radio-button  *ngIf="currentEnv !== 'qa'" value="qa">Qa Server</mat-radio-button>
      <mat-radio-button *ngIf="currentEnv !== 'prod'" value="prod">Production Server</mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="section">
    <label class="label">Select Application</label>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Select</mat-label>
      <mat-select [(ngModel)]="selectedApplication">
        <mat-option *ngFor="let proj of projectsBasedOnServer" [value]="proj.project_id">
          {{ proj.project_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="dailog-footer-buttons">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-raised-button color="primary" (click)="onCopy()">Copy</button>
</mat-dialog-actions>
</div>

<vl-spinner id="project_new" [show]="spinnerVisible"></vl-spinner>
}
